module.exports = __webpack_public_path__ + "cbb5ea608886e4187fdf479c04da4944.png";